import classNames from 'classnames';

// Centralized breakpoint constants for consistency
export const BREAKPOINTS = {
  XS: 350,
  SM: 576,
  MD: 896,
  LG: 1280,
  FALLBACK_SM: 544,
  FALLBACK_MD: 992
};

/*
Container Query Breakpoints:
@sm, @md, @lg, etc. are container-based responsive breakpoints that activate
when a parent element has className="sui-@container" applied.

Unlike traditional media queries that respond to viewport size, these breakpoints
respond to the container's width, enabling component-level responsive design.

For implementation details, see the Stencil Container Queries documentation.
*/

export const showAboveSmBreakpoint = classNames(
  'sui-hidden',
  '@sm:sui-block'
);

export const showBelowSmBreakpoint = classNames(
  'sui-block',
  '@sm:sui-hidden'
);

export const showAboveSmBreakpointIf = (condition) => classNames('sui-hidden', { '@sm:sui-block': condition });

// When passing custom className props to cards, include these classes to maintain base card design
export const defaultCardContentProps = classNames(
  'sui-flex',
  'sui-overflow-hidden',
  'sui-p-4',
  'sui-gap-4',
  'sui-flex-col'
);

export const listTitleStyles = classNames(
  'sui-text-base',
  '@2xl:sui-text-lg',
  'sui-text-primary',
  'sui-font-bold',
  'sui-capitalize'
);
